import { createContext, useContext } from 'react';

export interface FlowContextValue {
    next: () => void;
    back: () => void;
    goToStep: (id: number) => void;
    currentStep: number;
    isFirstStep: boolean;
    isLastStep: boolean;
}

export const FlowContext = createContext<FlowContextValue>({
    next: () => undefined,
    back: () => undefined,
    goToStep: () => undefined,
    currentStep: 0,
    isFirstStep: true,
    isLastStep: false,
});

export const useFlow = () => useContext(FlowContext);
